import useToggle from 'react-use/lib/useToggle';

import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { TranslatableText } from '@dreryk/react-common';
import { dispatchSnackbarPositiveEvent, Link, LinkSize } from '@dreryk/react-components';

import { patientEntitlementsTranslationKeys } from '../../translations';

import { OnPatientEntitlementDocumentCreated } from './PatientEntitlementCreateForm.types';
import { PatientEntitlementCreateModal } from './PatientEntitlementCreateModal';

type PatientEntitlementCreateLinkProps = {
   readonly patientId: Patient['id'];
   readonly label: TranslatableText;
   readonly icon?: JSX.Element;
   readonly onPatientEntitlementsDocumentCreated: OnPatientEntitlementDocumentCreated;
};

export const PatientEntitlementCreateLink = (props: PatientEntitlementCreateLinkProps): JSX.Element => {
   const [modalCreateVisible, toggleModalCreateVisible] = useToggle(false);

   const handlePatientEntitlementsDocumentCreated: OnPatientEntitlementDocumentCreated = (entitlementType) => {
      toggleModalCreateVisible(false);
      dispatchSnackbarPositiveEvent(patientEntitlementsTranslationKeys.additionalEntitlementDocumentWasSaved);
      props.onPatientEntitlementsDocumentCreated(entitlementType);
   };

   return (
      <>
         <Link
            testId={'addEntitlement'}
            label={props.label}
            icon={props.icon}
            onClick={toggleModalCreateVisible}
            size={LinkSize.NORMAL}
         />
         {modalCreateVisible ? (
            <PatientEntitlementCreateModal
               patientId={props.patientId}
               onCancel={toggleModalCreateVisible}
               onPatientEntitlementsDocumentCreated={handlePatientEntitlementsDocumentCreated}
            />
         ) : null}
      </>
   );
};
